export default "__VITE_ASSET__a2c1c283__"